import React from "react";
import PortfolioProps from "../components/WorkPages/PortfolioItem";
type Critique = {
  title: string;
  desc: string;
};

const kiwiCritiques: Critique[] = [
  {
    title: "Font Size",
    desc: "Font size in our initial hi-fi prototype was too small and difficult to read. We should make use of various font weights to emphasize the intention and hierarchy of each section. For text of similar importance, adjust the font size to be uniform throughout.",
  },
  {
    title: "Navigation",
    desc: "Navigation buttons at the bottom of the screen appeared too big and bulky. We can make it more sleek and modern-looking.",
  },
  {
    title: "Icon Accessibility",
    desc: "We used an airplane icon to symbolize sending Kiwis, which can cause confusion, as airplanes are not universally known to indicate sending messages. We can add descriptions to each of the navigation icons to limit ambiguity.",
  },
  {
    title: "Affordances",
    desc: "When pressing the settings icon and back button, we can allow the Settings page to slide in and out, imitating the action of swiping in a page and then swiping it away.",
  },
  {
    title: "App Intention",
    desc: "Consider the audience of the product that we were designing. Who is Kiwi intended for, and what is the functionality of it? We aim to make the app appear like a social media platform for songs.",
  },
];

export { kiwiCritiques };
